// extracted by mini-css-extract-plugin
export default {"header":"App_header__fhC8n","burguer":"App_burguer__bGqDR","navbar":"App_navbar__gqftH","footer":"App_footer__aawhi"};